import { render, staticRenderFns } from "./CurriculumSUnits.vue?vue&type=template&id=a2a69878&scoped=true&lang=pug&"
import script from "./CurriculumSUnits.vue?vue&type=script&lang=ts&"
export * from "./CurriculumSUnits.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumSUnits.vue?vue&type=style&index=0&id=a2a69878&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a69878",
  null
  
)

export default component.exports